import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BlockSizeSelectorSC, SizeButton } from './block-size-selector.styled';

const BLOCKS_SIZES = [15, 30, 45, 60];

interface BlockSizeSelectorProps {
  value?: number;
  onChange?: (size: number) => void;
  style?: React.CSSProperties;
}

const BlockSizeSelector: React.FunctionComponent<BlockSizeSelectorProps> = ({
  value,
  onChange,
  style,
}) => {
  return (
    <BlockSizeSelectorSC style={style}>
      <label>
        <FormattedMessage id="addForm_size_label" />
      </label>
      <div className="size-actions">
        {BLOCKS_SIZES.map((size) => (
          <SizeButton
            key={size}
            active={value === size}
            onClick={() => onChange?.(size)}
            type="button"
          >
            <span className="text">{size}</span>
          </SizeButton>
        ))}
        <span className="units">
          <FormattedMessage id="addForm_size_unit" />
        </span>
      </div>
    </BlockSizeSelectorSC>
  );
};

export default React.memo(BlockSizeSelector);
